import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "profile-dropdwn__name" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { List } from '@/@types/components/ui/lists';

import SmList from '@/components/ui/SmList/SmList.vue';
import SmTextButton from '@/components/ui/buttons/SmTextButton/SmTextButton.vue';

import '@/components/layout/SmProfileDropdown/style.scss';

// Composable


export default /*#__PURE__*/_defineComponent({
  __name: 'SmProfileDropdown',
  props: {
    modelValue: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const store = useStore()
const router = useRouter()
const { t } = useI18n()

// Props



// Emits



// Computed
const userName = computed((): string => {
  let fio = store.getters['user/getUser']?.fio?.split(' ') || '';

  if (fio.length >= 2) return `${fio[1]} ${fio[0][0]}.`;
  if (fio.length === 1) return fio[0];
  return '';
})

const list = computed((): List => ([
  userName.value,
  'Выход'
]))

// Methods

const handleToProfile = () => {
  router.push({ name: 'Profile' });
  emits('update:modelValue', false);
}

const handleLogout = () => {
  store.dispatch('auth/logout');
  emits('update:modelValue', false);
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(SmList, {
    list: list.value,
    class: "profile-dropdwn"
  }, {
    default: _withCtx(({ index, item }) => [
      (index === 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("span", _hoisted_1, _toDisplayString(item), 1),
            _createVNode(SmTextButton, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleToProfile()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('profile')), 1)
              ]),
              _: 1
            })
          ], 64))
        : (_openBlock(), _createBlock(SmTextButton, {
            key: 1,
            type: "text",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleLogout()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('logout')), 1)
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["list"])), [
    [_vShow, props.modelValue]
  ])
}
}

})